import React, { useEffect, useState } from "react";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";
import DataTable from "react-data-table-component";
import CustomLoader from "../../CustomComponents/loader/CustomLoader";
import HttpClientXml from "../../utils/HttpClientXml";
import HomeServices from "../../Services/HomeServices";
import "./Pages.css";
import Swal from "sweetalert2";
import { Form, Link, useNavigate } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import BackPageBtn from "../BackButton/BackPageBtn";

const ManageService = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const imgURL = "https://api.deshvidesh.ca";


  const [allData, setAllData] = useState();
  const [editId, setEditId] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);

  const initValue = {
    serviceName: "",
    documentation: selectedTypes
  };
  const [formValue, setFormValue] = useState(initValue);

  const fetchDocumentTypes = async () => {
    try {
      // Call your API function
      const response = await HomeServices.getAllDocumentTypes();
      console.log("WED62", response.data);
      if (response && response?.status) {
        setDocumentTypes(response.data)
      };

    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  console.log("jhsgdfjhakd", editId);

  const [isEdit, setIsEdit] = useState(true);
  const [editData, setEditData] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue((prev) => ({ ...prev, [name]: value }));
  };

  // submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("alldasdasdd", formValue);
    // return
    const { title, description } = formValue;
    const isValid = title.trim() !== "" && description.trim() !== "";

    if (isValid) {
      if (formValue?.image1 === "" || formValue?.image2 === "") {
        return toast.error("Please Upload Images");
      } else {
        const res = await HomeServices.addBlog(formValue);
        // console.log("resCat", res)
        if (res && res?.status) {
          toast.success("Blog Added Successfully");
          fetchData();

          // navigate('/manage-category');
          setIsLoading(false);
          console.log("formValue21456", formValue);
        } else {
          toast.error(res?.message || "Something Wrong");
          setIsLoading(false);
        }
      }
    } else {
      toast.error("Please Fill All The Inputs, Including the Image.");
    }
  };

  const columns = [
    { name: "SL No.", selector: "sln", sortable: true },
    { name: "Name", selector: "serviceName", wrap: true },
    { name: "Documents", selector: "documentsCount", wrap: true },
    { name: "Action", selector: "action", wrap: true },
  ];

  const fetchData = async () => {
    try {
      // Call your API function
      const response = await HomeServices.getAllServices();
      console.log("SER86", response);
      if (response && response?.status) {
        let arr = response?.data?.reverse()?.map((ele, index) => {

          return {
            sln: index + 1,
            serviceName: ele?.serviceName,
            documentation: ele?.documentation,
            documentsCount: ele?.documentation?.length,

            action: (
              <>
                <div>
                  {/* Edit Icon */}
                  <span title="Edit" onClick={(e) => handleEdit(e, ele)}>
                    <i
                      className="fa-regular fa-pen-to-square"
                      style={{
                        cursor: "pointer",
                        padding: "5px",
                        marginRight: "10px",
                        fontSize: "1.5em",
                        color: " #477DA5",
                        backgroundColor: "#E9F3F7",
                      }}
                    ></i>
                  </span>

                  {/* Delete Icon */}
                  <span title="Delete" onClick={() => handleDelete(ele?._id)}>
                    <i
                      className="fa-regular fa-trash-can"
                      style={{
                        cursor: "pointer",
                        marginRight: "10px",
                        padding: "5px",
                        fontSize: "1.5em",
                        color: "#C4554D",
                        backgroundColor: "#FAECEC",
                      }}
                    ></i>
                  </span>
                </div>
              </>
            ),
          };
        });
        setAllData(arr);

      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };


  useEffect(() => {
    fetchDocumentTypes()
    fetchData();
  }, []);


  // click on edit
  const handleEdit = (e, ele) => {
    e.preventDefault();
    console.log("FTY164", ele);

    window.scrollTo(0, 0);
    setSelectedTypes(ele.documentation)
    setEditMode(true);
    setEditId(ele?._id);
    setFormValue({
      serviceName: ele.serviceName,
      documentation: ele.documentation
    });

  };

  const handleDelete = async (id) => {
    console.log("deleteblogid", id);
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      console.log("result", result);
      if (result?.isConfirmed) {
        HomeServices.deleteService(id)
          .then((res) => {
            if (res && res.status) {
              toast.success("Deleted Successfully");
              fetchData();
            } else {
              toast.error(res?.message);
            }
          })
          .catch((err) => {
            console.error("Error deleting document:", err);
          });
      } else {
        console.log("Deletion canceled");
      }
    });
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setSelectedTypes((prev) =>
      checked ? [...prev, value] : prev.filter((type) => type !== value)
    );
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!formValue?.serviceName) return toast.error("Service Name should not be empty")

    await HomeServices.updateService(editId, formValue)
      .then((res) => {
        if (res && res?.status) {
          toast.success("update successfully");
          setFormValue(initValue);
          setEditMode(false);
          fetchData();
        } else {
          toast.error(res?.message || "Failed to update");
        }
      })
      .catch((err) => {
        toast.error(err?.message || "An error occurred");
        console.error("err", err);
      });
  };

  useEffect(() => {
    setFormValue({ ...formValue, documentation: selectedTypes })
  }, [selectedTypes])

  return (
    <>
      <CustomLoader loading={isLoading} />

      {
        editMode &&
        <div className="d-flex justify-content-end mt-5">
          <div className="form-header">
            <section className="piechartsBox_area">
              <form>
                <div>
                  <h1 style={{ color: "#ff9c00" }}>Update Service</h1>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <label htmlFor="formGroupExampleInput">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Service Name"
                      name="serviceName"
                      value={formValue?.serviceName}
                      onChange={(e) => { setFormValue({ ...formValue, serviceName: e.target.value }) }}
                    />
                  </div>
                </div>

                {/* <div className="row mt-4">
                  <div className="col">
                    <label htmlFor="formGroupExampleInput">Required Documents</label>
                    {documentTypes.map((type, key) => (
                      <div key={key}>
                        <label>
                          <input
                            type="checkbox"
                            value={type._id}
                            checked={selectedTypes.includes(type._id)}
                            onChange={handleCheckboxChange}
                            style={{ marginRight: "10px" }}
                          />
                          {type.document}
                        </label>
                      </div>
                    ))}
                  </div>
                </div> */}

                <div className="row mt-4">
                  <div className="col">
                    <label htmlFor="formGroupExampleInput" className="form-label">
                      Required Documents
                    </label>
                    {documentTypes.map((type, key) => {
                      const isChecked = selectedTypes.includes(type._id);
                      return (
                        <div key={key}>
                          <label
                            className={`checkbox-label ${isChecked ? 'checked' : ''}`}
                          >
                            <input
                              type="checkbox"
                              value={type._id}
                              checked={isChecked}
                              onChange={handleCheckboxChange}
                              style={{ marginRight: "10px" }}
                            />
                            {type.document}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>


                {/* <div className="row mt-5">
                <div className="col-md-12">
                  <label htmlFor="formGroupExampleInput">Description</label>
                  <textarea
                    className="form-control"
                    rows={6}
                    name="description"
                    value={formValue?.description}
                    onChange={(e) => { setFormValue({ ...formValue, description: e.target.value }) }}
                  ></textarea>
                </div>
              </div> */}



                <div class="col-12 ">

                  <button
                    type="submit"
                    onClick={(e) => handleUpdate(e)}
                    class="btn btn-primaryb mt-3 addBlogBtn"
                    style={{
                      background: "linear-gradient(195deg, #FFB14C, #ff9000)",
                      color: "#fff",
                    }}
                  >
                    Update
                  </button>
                  <button
                    type="button"
                    onClick={(e) => setEditMode(false)}
                    class="btn btn-primaryb mt-3"

                  >
                    Cancel
                  </button>

                </div>
              </form>
            </section>
          </div>
        </div>
      }


      {
        !editMode && allData?.length > 0 && (
          <>

            <div className="d-flex justify-content-end">
              <div className="form-header">
                <section className="piechartsBox_area">
                  <div>
                    <div className="dateListDiv">
                      <h1
                        style={{
                          color: "#ff9c00",
                          fontSize: "25px",
                          fontWeight: "600",
                          marginBottom: "10px",
                        }}
                      >
                        View Services
                      </h1>

                    </div>
                  </div>

                  <hr />
                  <DataTable columns={columns} data={allData} pagination />
                </section>
              </div>
            </div>
          </>
        )
      }

    </>
  );
};

export default ManageService;
